const API_URL = 'https://sheetdb.io/api/v1/qa8ftkry70910';

export const isPublishedBlog = (blog) => {
  return (
    blog?.status?.toLowerCase() === 'deployed' &&
    Boolean(blog?.title?.trim()) &&
    Boolean(blog?.slug?.trim()) &&
    Boolean(blog?.content?.trim())
  );
};

const getBlogTimestamp = (blog) => {
  const candidate = blog?.updatedAt || blog?.date || blog?.publishedAt || blog?.createdAt;
  const timestamp = Date.parse(candidate);
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const sortBlogsByRecent = (blogs = []) => {
  return [...blogs].sort((a, b) => {
    const delta = getBlogTimestamp(b) - getBlogTimestamp(a);
    if (delta !== 0) return delta;

    return (b?.title || '').localeCompare(a?.title || '');
  });
};

export const filterPublishedBlogs = (blogs = []) => {
  return sortBlogsByRecent(blogs.filter(isPublishedBlog));
};

// Simple in-memory cache to avoid redundant API calls
let cachedBlogs = null;
let cacheTimestamp = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes
let pendingRequest = null;

export const getBlogs = async () => {
  // Return cached data if fresh
  if (cachedBlogs && Date.now() - cacheTimestamp < CACHE_TTL) {
    return cachedBlogs;
  }

  // Deduplicate concurrent requests
  if (pendingRequest) return pendingRequest;

  pendingRequest = (async () => {
    try {
      const response = await fetch(API_URL);
      if (!response.ok) {
        throw new Error(`Failed to fetch blogs: ${response.statusText}`);
      }
      const data = await response.json();
      cachedBlogs = filterPublishedBlogs(data);
      cacheTimestamp = Date.now();
      return cachedBlogs;
    } catch (error) {
      console.error('Error fetching blogs:', error);
      throw error;
    } finally {
      pendingRequest = null;
    }
  })();

  return pendingRequest;
};
